"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SVGIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PetSureIconSets = require("../PetSure/PetSureIconSets");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SVGIcon = _ref => {
  let {
    iconName,
    size = {
      width: 30,
      height: 30
    }
  } = _ref;
  // eslint-disable-next-line no-console
  const {
    paths,
    width,
    height
  } = _PetSureIconSets.FlatPetSureIconSet[iconName];
  const viewBox = "0 0 ".concat(width || height, " ").concat(height);
  if (paths) {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: size.width,
      height: size.height,
      viewBox: viewBox,
      xmlns: "http://www.w3.org/2000/svg"
    }, paths.map((path, index) =>
    /*#__PURE__*/
    /* eslint-disable-next-line react/no-array-index-key */
    _react.default.createElement("path", {
      d: path,
      key: "".concat(iconName, "_").concat(index)
    })));
  }
  return null;
};
exports.SVGIcon = SVGIcon;
SVGIcon.propTypes = {
  iconName: _propTypes.default.oneOf(_PetSureIconSets.PetSureIconList),
  size: _propTypes.default.shape({
    width: _propTypes.default.number,
    height: _propTypes.default.number
  })
};
var _default = exports.default = SVGIcon;